import '../tracking/CreatePopUp.css'
import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
//svg
import WhiteCloseSvg from '../../svgs/WhiteCloseSvg'
import { RISKASSESSMENT_DEFAULT_TYPE } from '../../config';
import { fetchRiskAssessmentTemplateList } from '../../services/riskAssessments.service';

function CreatePopUp(props) {
    const navigate = useNavigate();
    const location = useLocation()
    
    const [filterType, setFilterType] = useState('All')
    const [data, setData] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState([])
    useEffect(() => {
        fetchData()
    }, [filterType])
    async function fetchData() {
        const filter = {}
        if (filterType !== 'All') filter['type'] = { "$eq": `${filterType}` }
        filter.projectId = props.control.projectId
        const res = await fetchRiskAssessmentTemplateList(props.token.token, filter, {})
        if (res.errno) return console.log('error fetching data')

        setData(res.result)
        // console.log(res.result)
    }
    function handleSelectedTemplate(obj) {
        let newSelected = [...selectedTemplate]
        //push new obj by copy not by reference, including nested array
        newSelected.push(JSON.parse(JSON.stringify(obj)))
        setSelectedTemplate(newSelected)
    }
    function handleCreate() {
        if (selectedTemplate.length === 0){
            alert('Please select at least one template')
            return
        }
        const state = {
            data: selectedTemplate, 
            createdBy: props.control.userData._id,
            isEmergency: location.pathname === '/risk-assessment/emergency',
        }
        navigate('/risk-assessment/work-order/create', { state })
    }
    return (
        <div className="w-[35%] max-w-[95%] max-h-[80%] min-h-[646px] border border-[#FFFFFF80] rounded bg-[#363636B2] p-[40px] text-white flex flex-col" style={{ zIndex: 99, minWidth: 'min( 850px , 100% )' }}>
            <div className="flex flex-row justify-between mb-8">
                <div className="text-[18px] font-bold">Select Template</div>
                <WhiteCloseSvg className='cursor-pointer' onClick={() => { props.handlePermPop(false) }} />
            </div>
            <div className='flex flex-row items-center flex-wrap'>
                {['All', ...RISKASSESSMENT_DEFAULT_TYPE].map((type) => <div key={type} onClick={() => setFilterType(type)} className='p-[8px] text-nowrap flex-1 cursor-pointer select-none' style={filterType === type ? { borderBottomColor: 'white', borderBottomWidth: 1 } : { borderBottomColor: '#FFFFFF80', borderBottomWidth: 1 }}>
                    {type}
                </div>)}
            </div>
            <div className='w-full flex-1 overflow-y-scroll mt-[32px] flex-1'>
                {data.length > 0 && data.map((assessmentObj, i) => <div key={assessmentObj._id} className='flex flex-row items-center mb-[16px] gap-[16px]'>
                    <div className='border-white border-[1px] w-[24px] h-[24px] rounded-[12px] hover:opacity-[.5] flex justify-center items-center cursor-pointer' onClick={() => handleSelectedTemplate(assessmentObj)} >
                        <div className='font-[700] mt-[-1px] mr-[-1px]'>+</div>
                    </div>
                    <div>{assessmentObj.name} <span className='text-[#949494]'>| {assessmentObj.templateType || assessmentObj?.type}</span></div>
                </div>)}
            </div>
            <div className="text-[18px] font-bold mt-[24px] w-full" style={{ borderBottom: '.5px solid white' }}>Selected Forms</div>
            <div className='w-full flex-1 overflow-y-scroll mt-[8px] flex-1'>
                {selectedTemplate.length > 0 && selectedTemplate.map((assessmentObj, i) =>
                    <div key={i} className='flex flex-row items-center mb-[16px] gap-[16px]'>
                        <div className='border-white border-[1px] w-[24px] h-[24px] rounded-[12px] hover:opacity-[.5] flex justify-center items-center cursor-pointer' onClick={() => {
                            let newSelected = [...selectedTemplate]
                            newSelected.splice(i, 1)
                            setSelectedTemplate(newSelected)
                        }} >
                            <div className='font-[700] mt-[-1px] mr-[-1px]'>-</div>
                        </div>
                        <div>{assessmentObj.name} <span className='text-[#949494]'>| {assessmentObj.templateType || assessmentObj?.type}</span></div>
                    </div>
                )}
            </div>
            <div className="flex flex-col mb-4">
                <div onClick={handleCreate} type="submit" className='flex flex-row items-center justify-center bg-[#00202A] text-[#63BDFF] border-none h-[40px] rounded-full cursor-pointer mt-[32px]'>Select</div>
            </div>
        </div>
    )
}
export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(CreatePopUp)